import { useBlockProps, InspectorControls, BlockControls } from "@wordpress/block-editor";
import { PanelBody, SelectControl, TextControl, TextareaControl, Disabled, ToolbarGroup, ToolbarDropdownMenu } from "@wordpress/components";
import DebouncedServerSideRender from "../../../shared/js/DebouncedServerSideRender";
import { __ } from "@wordpress/i18n";

const VARIANT_OPTIONS = [
    { label: __("Default", "content-egg"), value: "default" },
    { label: __("Compact", "content-egg"), value: "compact" },
];

const TYPE_OPTIONS = [
    { label: __("Note", "content-egg"), value: "note" },
    { label: __("Tip", "content-egg"), value: "tip" },
    { label: __("Warning", "content-egg"), value: "warning" },
    { label: __("Insight", "content-egg"), value: "insight" },
];

const COLOR_SCHEME_OPTIONS = [
    { label: __("Auto (site default)", "content-egg"), value: "auto" },
    { label: __("Light", "content-egg"), value: "light" },
    { label: __("Dark", "content-egg"), value: "dark" },
];

export default function Edit({ attributes, setAttributes }) {
    const blockProps = useBlockProps({ className: attributes.align ? `align${attributes.align}` : "" });
    const { variant, callout_type, color_scheme, label_type, title, body } = attributes;
    const hasPreviewContent = body?.trim() || (variant === "default" && title?.trim());

    return (
        <>
            <BlockControls>
                <ToolbarGroup>
                    <ToolbarDropdownMenu
                        icon="screenoptions"
                        label={__("Variant", "content-egg")}
                        text={VARIANT_OPTIONS.find((o) => o.value === variant)?.label}
                        controls={VARIANT_OPTIONS.map((option) => ({
                            title: option.label,
                            isActive: variant === option.value,
                            onClick: () => setAttributes({ variant: option.value }),
                        }))}
                    />
                </ToolbarGroup>
            </BlockControls>

            <InspectorControls>
                <PanelBody title={__("Layout", "content-egg")} initialOpen={true}>
                    <SelectControl
                        label={__("Variant", "content-egg")}
                        value={variant}
                        options={VARIANT_OPTIONS}
                        onChange={(value) => setAttributes({ variant: value })}
                        __nextHasNoMarginBottom
                    />
                    <SelectControl
                        label={__("Type", "content-egg")}
                        value={callout_type}
                        options={TYPE_OPTIONS}
                        onChange={(value) => setAttributes({ callout_type: value })}
                        __nextHasNoMarginBottom
                    />
                    <SelectControl
                        label={__("Color Scheme", "content-egg")}
                        value={color_scheme}
                        options={COLOR_SCHEME_OPTIONS}
                        onChange={(value) => setAttributes({ color_scheme: value })}
                        __nextHasNoMarginBottom
                    />
                </PanelBody>

                <PanelBody title={__("Content", "content-egg")} initialOpen={true}>
                    <TextControl
                        label={__("Type Label", "content-egg")}
                        value={label_type}
                        placeholder={__("Use default for type", "content-egg")}
                        onChange={(value) => setAttributes({ label_type: value })}
                    />
                    {variant === "default" && (
                        <TextControl
                            label={__("Title", "content-egg")}
                            value={title}
                            onChange={(value) => setAttributes({ title: value })}
                        />
                    )}
                    <TextareaControl
                        label={__("Body", "content-egg")}
                        value={body}
                        onChange={(value) => setAttributes({ body: value })}
                        rows={variant === "compact" ? 3 : 5}
                        __nextHasNoMarginBottom
                    />
                </PanelBody>
            </InspectorControls>

            <div {...blockProps}>
                {hasPreviewContent ? (
                    <Disabled>
                        <DebouncedServerSideRender
                            block="eggb/callout"
                            attributes={attributes}
                        />
                    </Disabled>
                ) : (
                    <p style={{ color: "#999", fontStyle: "italic", padding: "16px", margin: 0, fontSize: "13px" }}>
                        {__("Add callout body text in the sidebar.", "content-egg")}
                    </p>
                )}
            </div>
        </>
    );
}
